import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClientRoutingModule } from './client-routing.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { LeftmenuComponent } from './leftmenu/leftmenu.component';

import { FooterComponent } from './footer/footer.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { WidgetsComponent } from './widgets/widgets.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UiElementsComponent } from './ui-elements/ui-elements.component';
import { UiTabsComponent } from './ui-elements/ui-tabs/ui-tabs.component';
import { UiSpinnersComponent } from './ui-elements/ui-spinners/ui-spinners.component';
import { UiScrollspyComponent } from './ui-elements/ui-scrollspy/ui-scrollspy.component';
import { UiPaginationComponent } from './ui-elements/ui-pagination/ui-pagination.component';
import { UiProcessbarComponent } from './ui-elements/ui-processbar/ui-processbar.component';
import { UiNotificationComponent } from './ui-elements/ui-notification/ui-notification.component';
import { UiModalsComponent } from './ui-elements/ui-modals/ui-modals.component';
import { UiMediaObjectComponent } from './ui-elements/ui-media-object/ui-media-object.component';
import { UiListGroupComponent } from './ui-elements/ui-list-group/ui-list-group.component';
import { UiIconsComponent } from './ui-elements/ui-icons/ui-icons.component';
import { UiDailogsComponent } from './ui-elements/ui-dailogs/ui-dailogs.component';
import { UiColorsComponent } from './ui-elements/ui-colors/ui-colors.component';
import { UiCollapseComponent } from './ui-elements/ui-collapse/ui-collapse.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { UiCardsComponent } from './ui-elements/ui-cards/ui-cards.component';
import { UiButtonsComponent } from './ui-elements/ui-buttons/ui-buttons.component';
import { UiBreadcrumbComponent } from './ui-elements/ui-breadcrumb/ui-breadcrumb.component';
import { UiBadgesComponent } from './ui-elements/ui-badges/ui-badges.component';
import { UiAlertsComponent } from './ui-elements/ui-alerts/ui-alerts.component';
import { PagesComponent } from './pages/pages.component';
import { StarterpageComponent } from './pages/starterpage/starterpage.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { TimelineComponent } from './pages/timeline/timeline.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { FaqsComponent } from './pages/faqs/faqs.component';
import { SearchResultComponent } from './pages/search-result/search-result.component';
import { WorldmapComponent } from './worldmap/worldmap.component';
import { AgmCoreModule } from '@agm/core';
import { MapComponent } from './map/map.component';
import { DocumentsComponent } from './documents/documents.component';
import { SettingsComponent } from './settings/settings.component';
import { FormsComponent } from './forms/forms.component';
import { TablesComponent } from './tables/tables.component';
import { FullcalenderComponent } from './fullcalender/fullcalender.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import interactionPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/daygrid';
import { CalenderComponent } from './calender/calender.component';
import { ContactComponent } from './contact/contact.component';
import { FileManagerComponent } from './file-manager/file-manager.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ChartsComponent } from './charts/charts.component';
import { AreaChartComponent } from './charts/area-chart/area-chart.component';
import { BarChartComponent } from './charts/bar-chart/bar-chart.component';
import { BasicradarChartComponent } from './charts/basicradar-chart/basicradar-chart.component';
import { CandlestickChartComponent } from './charts/candlestick-chart/candlestick-chart.component';
import { ColumnLineChartComponent } from './charts/column-line-chart/column-line-chart.component';
import { ColumnChartComponent } from './charts/column-chart/column-chart.component';
import { HeatmapChartComponent } from './charts/heatmap-chart/heatmap-chart.component';
import { LineChartComponent } from './charts/line-chart/line-chart.component';
import { MinbarChartComponent } from './charts/minbar-chart/minbar-chart.component';
import { PieChartComponent } from './charts/pie-chart/pie-chart.component';
import { RadarChartComponent } from './charts/radar-chart/radar-chart.component';
import { RadialbarChartComponent } from './charts/radialbar-chart/radialbar-chart.component';
import { SparklinesComponent } from './charts/sparklines/sparklines.component';
import { NgApexchartsModule } from "ng-apexcharts";
import { CkeditorComponent } from './ckeditor/ckeditor.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ChatLeftmenuComponent } from './leftmenu/chat-leftmenu/chat-leftmenu.component';
import { ChatComponent } from './chat/chat.component';
import { VideoCallRoomComponent } from './chat/video-call-room/video-call-room.component';
import { AudioCallRoomComponent } from './chat/audio-call-room/audio-call-room.component';
import { GroupChatComponent } from './chat/group-chat/group-chat.component';
import { SingleChatComponent } from './chat/single-chat/single-chat.component';
import { SingleChat2Component } from './chat/single-chat2/single-chat2.component';
import { BotChatComponent } from './chat/bot-chat/bot-chat.component';
import { EventComponent } from './event/event.component';
import { EventLeftmenuComponent } from './leftmenu/event-leftmenu/event-leftmenu.component';
import { EventAddComponent } from './event/event-add/event-add.component';
import { EventAllComponent } from './event/event-all/event-all.component';
import { EventCalenderComponent } from './event/event-calender/event-calender.component';
import { EventDraftComponent } from './event/event-draft/event-draft.component';
import { EventMemberComponent } from './event/event-member/event-member.component';
import { EventMessageComponent } from './event/event-message/event-message.component';
import { EventMyComponent } from './event/event-my/event-my.component';
import { ProjectComponent } from './project/project.component';
import { ProjectLeftmenuComponent } from './leftmenu/project-leftmenu/project-leftmenu.component';
import { AppProjectComponent } from './project/app-project/app-project.component';
import { AppProjectAddComponent } from './project/app-project-add/app-project-add.component';
import { AppProjectCalenderComponent } from './project/app-project-calender/app-project-calender.component';
import { AppProjectDetailComponent } from './project/app-project-detail/app-project-detail.component';
import { AppProjectInvoiceComponent } from './project/app-project-invoice/app-project-invoice.component';
import { AppProjectInvoiceCreateComponent } from './project/app-project-invoice-create/app-project-invoice-create.component';
import { AppProjectInvoiceDetailComponent } from './project/app-project-invoice-detail/app-project-invoice-detail.component';
import { AppProjectKanbanBoardComponent } from './project/app-project-kanban-board/app-project-kanban-board.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
// a plugin
FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  timeGridPlugin,
  interactionPlugin
]);
@NgModule({
  imports: [
    CommonModule,
    ClientRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    CollapseModule.forRoot(),
    FullCalendarModule,
    NgApexchartsModule,
    CKEditorModule,
    AccordionModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    DragDropModule,
    AgmCoreModule.forRoot({
      apiKey: 'GOOGLE API KEY'
    })

  ],
  declarations: [
    ClientRoutingModule.components,
    LeftmenuComponent,
    FooterComponent,
    DashboardComponent,
    WidgetsComponent,
    UiElementsComponent,
    UiTabsComponent,
    UiSpinnersComponent,
    UiScrollspyComponent,
    UiPaginationComponent,
    UiProcessbarComponent,
    UiNotificationComponent,
    UiModalsComponent,
    UiMediaObjectComponent,
    UiListGroupComponent,
    UiIconsComponent,
    UiDailogsComponent,
    UiColorsComponent,
    UiCollapseComponent,
    UiCardsComponent,
    UiButtonsComponent,
    UiBreadcrumbComponent,
    UiBadgesComponent,
    UiAlertsComponent,
    PagesComponent,
    StarterpageComponent,
    ProfileComponent,
    GalleryComponent,
    TimelineComponent,
    PricingComponent,
    InvoicesComponent,
    FaqsComponent,
    SearchResultComponent,
    WorldmapComponent,
    MapComponent,
    DocumentsComponent,
    SettingsComponent,
    FormsComponent,
    TablesComponent,
    FullcalenderComponent,
    CalenderComponent,
    ContactComponent,
    FileManagerComponent,
    ChartsComponent,
    AreaChartComponent,
    BarChartComponent,
    BasicradarChartComponent,
    CandlestickChartComponent,
    ColumnLineChartComponent,
    ColumnChartComponent,
    HeatmapChartComponent,
    LineChartComponent,
    MinbarChartComponent,
    PieChartComponent,
    RadarChartComponent,
    RadialbarChartComponent,
    SparklinesComponent,
    CkeditorComponent,
    ChatLeftmenuComponent,
    ChatComponent,
    VideoCallRoomComponent,
    AudioCallRoomComponent,
    GroupChatComponent,
    SingleChatComponent,
    SingleChat2Component,
    BotChatComponent,
    EventComponent,
    EventLeftmenuComponent,
    EventAddComponent,
    EventAllComponent,
    EventCalenderComponent,
    EventDraftComponent,
    EventMemberComponent,
    EventMessageComponent,
    EventMyComponent,
    ProjectComponent,
    ProjectLeftmenuComponent,
    AppProjectComponent,
    AppProjectAddComponent,
    AppProjectCalenderComponent,
    AppProjectDetailComponent,
    AppProjectInvoiceComponent,
    AppProjectInvoiceCreateComponent,
    AppProjectInvoiceDetailComponent,
    AppProjectKanbanBoardComponent,

  ],
  providers: []
})
export class ClientModule { }
